import API from './API.ts'

export default {
  //
  // GET
  //
  getProducts () {
    return API.httpClient.get('products')
  },
  getProduct ({ productId }) {
    return API.httpClient.get('products/show', {
      params: {
        product_id: productId
      }
    })
  },
  getPaginatedProducts ({ requestId, offset, visibleProducts, sortedColumn, sortedDesc, searchString, filterProductGroupId, filterStatus }) {
    return API.httpClient.get('products/paginated', {
      params: {
        request_id: requestId,
        offset,
        visible_products: visibleProducts,
        sorted_column: sortedColumn,
        sorted_desc: sortedDesc,
        search_string: searchString,
        filter_product_group_id: filterProductGroupId,
        filter_status: filterStatus
      }
    })
  },
  getProductGroups () {
    return API.httpClient.get('product-groups')
  },
  getProductGroupsForTable () {
    return API.httpClient.get('product-groups/table')
  },
  getProductGroup ({ productGroupId }) {
    return API.httpClient.get('product-groups/show', {
      params: {
        product_group_id: productGroupId
      }
    })
  },
  getProductGroupProducts ({ productGroupId, offset, limit }) {
    return API.httpClient.get('product-groups/products', {
      params: {
        product_group_id: productGroupId,
        offset,
        limit
      }
    })
  },
  getProductLayoutTabs () {
    return API.httpClient.get('layouts/tabs')
  },
  getProductSalesHistory ({ productId }) {
    return API.httpClient.get('products/get-sales-history', {
      params: {
        product_id: productId
      }
    })
  },
  getRecentSalesItems ({ productId, offset, limit }) {
    return API.httpClient.get('products/recent-sales-items', {
      params: {
        product_id: productId,
        offset,
        limit
      }
    })
  },
  getCartCharges ({ productId }) {
    return API.httpClient.get('products/cart-charges', {
      params: {
        product_id: productId
      }
    })
  },
  getEditingRecords ({ productId }) {
    return API.httpClient.get('products/editing-records', {
      params: {
        product_id: productId
      }
    })
  },
  getProductGroupEditingRecords ({ productGroupId }) {
    return API.httpClient.get('product-groups/editing-records', {
      params: {
        product_group_id: productGroupId
      }
    })
  },

  //
  // POST
  //
  saveProduct ({ productId, name, productGroupId, barcode, price, guiColor, shouldHaveDeliveryDate, defaultDeliveryDate }) {
    return API.httpClient.post('products/save', {
      id: productId,
      name,
      product_group_id: productGroupId,
      barcode,
      price,
      gui_color: guiColor,
      should_have_delivery_date: shouldHaveDeliveryDate,
      default_delivery_date: defaultDeliveryDate
    })
  },
  saveProductGroup ({ productGroupId, name, accountId, productType }) {
    return API.httpClient.post('product-groups/save', {
      id: productGroupId,
      name,
      account_id: accountId,
      product_type: productType
    })
  },

  saveLayoutButton ({ button }) {
    const productIds = button.products.map(p => p.id)
    return API.httpClient.post('layouts/button', {
      button_id: button.id,
      product_layout_tab_id: button.product_layout_tab_id,
      button_color: button.button_color,
      button_text: button.button_text,
      column: button.column,
      row: button.row,
      type: button.type,
      product_ids: productIds
    })
  },
  moveLayoutButton ({ buttonId, row, column }) {
    return API.httpClient.post('layouts/button/move', {
      button_id: buttonId,
      row,
      column
    })
  },
  setTabOrder ({ tabIds }) {
    return API.httpClient.post('layouts/tab/move', {
      ordered_tab_ids: tabIds
    })
  },
  setTabPin ({ tabId, workstationId, togglePin }) {
    return API.httpClient.post('layouts/tab/pin', {
      tab_id: tabId,
      workstation_id: workstationId,
      toggle_pin: togglePin
    })
  },
  deleteProduct ({ productId }) {
    return API.httpClient.post('products/delete', {
      product_id: productId
    })
  },
  deleteProductGroup ({ productGroupId }) {
    return API.httpClient.post('product-groups/delete', {
      product_group_id: productGroupId
    })
  },
  deleteLayoutButton ({ buttonId }) {
    return API.httpClient.post('layouts/delete-button', {
      button_id: buttonId
    })
  }
}
